/* eslint-disable eqeqeq */
import {
  InvalidDataType,
  VALIDATE_IMPORT_FILE_TYPE,
} from "../components/input/arrayData/excel-template/template/_utils";
import { SharePointLinkType, SharePointPermissionRole } from "../constants/sharePointConstant";
import { IMicrosoftPeople } from "../models/IMicrosoft365";
import { ISharepointPermission, ISharepointUser } from "../models/ISharepoint";
import { get } from "lodash";

function getReadableFileSizeString(fileSizeInBytes: number) {
  var i = -1;
  var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
}

const getFileExt = (name: any) => {
  const arr = name.split(".");
  const tmp = arr[arr.length - 1];
  if (tmp.indexOf("?") > -1) {
    const checkQuest = tmp.split("?");
    return checkQuest[0];
  }
  return arr[arr.length - 1];
};

const getFileNameWithoutExt = (name: any) => {
  if (!name) return "";
  const arr = name.split(".");
  const ext = arr[arr.length - 1];
  const res = name.split(`.${ext}`);
  return res[0];
};

const getPeopleDisplay = (peoples: any) => {
  if (!peoples) {
    return "";
  }
  const arr = JSON.parse(peoples);
  const res: any[] = [];
  arr.forEach((p: any) => {
    res.push(p.displayName);
  });

  return res.join(",");
};

const getQueryVariable = (variable: any) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
};

const getFolderFromPath = (variable: string) => {
  if (!variable) return "";

  var vars = variable.split("/");
  return vars[vars.length - 1];
};

const getParentSubFolderPathFromSharePoint = (sharePointParentPath: string) => {
  if (!sharePointParentPath) return "";

  var vars = sharePointParentPath.split("root:/");
  return vars.length > 1 ? vars[vars.length - 1] : "";
};

const getFullDocumentUrl = (docUrl: string, siteUrl: string) => {
  if (docUrl) {
    if (docUrl.indexOf("http") !== 0) {
      return `${siteUrl}/${docUrl}`;
    }
    return docUrl;
  }

  return siteUrl;
};

const getStringByLength = (text: string, maxLength: number) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }

  return text;
};

const buildPeopleJsonFromPicker = (arr: any) => {
  let arrGroup: any = null;
  let arrUsers: any = null;
  let jsonArrayUsers: any = null;
  let jsonArrayGroups: any = null;
  arrUsers = arr.filter((user: any) => user.givenName?.length > 0);
  arrGroup = arr.filter((g: any) => g.groupTypes);
  jsonArrayUsers = arrUsers.map((p: any) => ({
    Claims: `i:0#.f|membership|${getEmailFromPeoplePicker(p) || p.securityIdentifier}`,
    Id: p.id,
    displayName: p.displayName,
    email: getEmailFromPeoplePicker(p),
    jobTitle: p.jobTitle ? p.jobTitle : "",
    departmentId: p.departmentId,
    department: p.department || "",
    departmentCode: p.departmentCode || "",
    pDeptCode: p.pDeptCode || "",
    isView: p.isView,
    isEdit: p.isEdit,
  }));
  jsonArrayGroups = arrGroup.map((p: any) => ({
    Claims: `c:0o.c|federateddirectoryclaimprovider|${p.id || p.securityIdentifier}`,
    Id: p.id,
    displayName: p.displayName,
    email: getEmailFromPeoplePicker(p),
    jobTitle: "",
    department: "",
  }));
  return JSON.stringify(jsonArrayUsers.concat(jsonArrayGroups));
};

const buildPeopleJsonFromBuildData = (arr: any) => {
  let arrGroup: any = null;
  let arrUsers: any = null;
  let jsonArrayUsers: any = null;
  let jsonArrayGroups: any = null;
  arrUsers = arr.filter((user: any) => user.givenName?.length > 0);
  arrGroup = arr.filter((g: any) => g.groupTypes);
  jsonArrayUsers = arrUsers.map((p: any) => ({
    Claims: `i:0#.f|membership|${getEmailFromPeoplePicker(p) || p.securityIdentifier}`,
    Id: p.id,
    displayName: p.displayName,
    email: getEmailFromPeoplePicker(p),
    jobTitle: p.jobTitle ? p.jobTitle : "",
    department: p.department || "",
    departmentCode: p.departmentCode || "",
  }));
  jsonArrayGroups = arrGroup.map((p: any) => ({
    Claims: `c:0o.c|federateddirectoryclaimprovider|${p.id || p.securityIdentifier}`,
    Id: p.id,
    displayName: p.displayName,
    email: getEmailFromPeoplePicker(p),
    jobTitle: "",
    department: "",
  }));
  return JSON.stringify(jsonArrayUsers.concat(jsonArrayGroups));
};

const getEmailFromPeoplePicker = (p: IMicrosoftPeople) => {
  return p.mail?.toLowerCase() ?? p.userPrincipalName?.toLowerCase();
};

const getEmailFromSharepointUser = (p: ISharepointUser) => {
  return p.email?.toLowerCase();
};

const getEmailFromPermissionData = (p: ISharepointPermission) => {
  return p.user?.email?.toLowerCase();
};

const getEmailsByBuildDataJson = (jsonPeopleOrGroups: string) => {
  return jsonPeopleOrGroups ? JSON.parse(jsonPeopleOrGroups).map((p: any) => p.email) : [];
};

const getIdsByBuildDataJson = (jsonPeopleOrGroups: string) => {
  return jsonPeopleOrGroups ? JSON.parse(jsonPeopleOrGroups).map((p: any) => p.Id) : [];
};

const getIdsByBuildDataArray = (peopleOrGroups: any) => {
  return peopleOrGroups ? peopleOrGroups.map((p: any) => p.Id) : [];
};

const getEmailsByBuildDataArray = (peopleOrGroups: any) => {
  return peopleOrGroups ? peopleOrGroups.map((p: any) => p.email) : [];
};

const getEmailsFromSharepointUsers = (users: Array<ISharepointUser>) => {
  return users ? users.map((u: any) => u.email) : [];
};

const getIdsBySharepointUers = (users: Array<ISharepointUser>) => {
  return users ? users.map((p: ISharepointUser) => p.id) : [];
};

const isEqualFromSharepointUsers = (source: ISharepointUser, dest: ISharepointUser) => {
  return source.id === dest.id || source.email?.toLocaleLowerCase() === dest.email?.toLocaleUpperCase();
};

const isEqualBetweenSharepointUserAndLoginUser = (source: ISharepointUser, userLogin: any) => {
  if (!source) return false;
  let result: boolean = false;
  if (userLogin?.current) {
    result = source.id?.toLocaleLowerCase() === userLogin.current.localAccountId?.toLocaleLowerCase();
  }

  if (!result && userLogin?.groupsOfUser) {
    const group = userLogin.groupsOfUser.find(
      (gu: any) => gu.mail && gu.mail?.toLocaleLowerCase() === source.email?.toLocaleLowerCase(),
    );
    if (group) result = true;
  }

  return result;
};

const addPeoplesFromPicker = (arr: any, values: any) => {
  // eslint-disable-next-line array-callback-return
  values.map((item: any) => {
    if (arr.find((a: any) => isEqualFromSharepointUsers(a, item)) == null) {
      arr.push(item);
    }
  });
};

const convertPeopleToSharepointUser = (peopleOrGroup: any) => {
  var result: ISharepointUser = {
    id: peopleOrGroup.id,
    displayName: peopleOrGroup.displayName,
    email: getEmailFromPeoplePicker(peopleOrGroup),
  };
  return result;
};

const convertUserLoginToSharepointUser = (userLogin: any) => {
  var result: ISharepointUser = {
    id: userLogin.current?.localAccountId,
    displayName: userLogin.current?.name,
    email: userLogin.current?.username,
  };
  return result;
};

const convertPeoplesToSharepointUsers = (peopleOrGroups: any) => {
  if (!peopleOrGroups) return null;

  return peopleOrGroups.map((p: any) => convertPeopleToSharepointUser(p));
};

const getRoleFromLinkType = (linkType: any) => {
  return linkType === SharePointLinkType.edit ? SharePointPermissionRole.write : SharePointPermissionRole.read;
};

const validatePhoneNumber = (phoneNumber: any) => {
  const phoneNumberRegex = /^(0[1-9]|84[1-9])(\d{8})$/;
  return phoneNumberRegex.test(phoneNumber);
};

const validateRequests = (requests: any[]) => {
  return requests.every((r) => {
    for (const [, v] of Object.entries(r)) {
      if (typeof v === "object" && !Array.isArray(v) && v !== null && get(v, "type") === VALIDATE_IMPORT_FILE_TYPE) {
        const { isValid } = r as InvalidDataType;
        return isValid;
      }
    }
    return true;
  });
};

export {
  getReadableFileSizeString,
  getFileExt,
  getPeopleDisplay,
  getQueryVariable,
  getFileNameWithoutExt,
  getFolderFromPath,
  getFullDocumentUrl,
  getStringByLength,
  buildPeopleJsonFromPicker,
  buildPeopleJsonFromBuildData,
  getEmailsByBuildDataJson,
  getEmailFromSharepointUser,
  getIdsByBuildDataJson,
  getIdsByBuildDataArray,
  getEmailsByBuildDataArray,
  getEmailFromPeoplePicker,
  getEmailFromPermissionData,
  addPeoplesFromPicker,
  getEmailsFromSharepointUsers,
  getIdsBySharepointUers,
  convertPeopleToSharepointUser,
  convertPeoplesToSharepointUsers,
  isEqualFromSharepointUsers,
  isEqualBetweenSharepointUserAndLoginUser,
  getRoleFromLinkType,
  getParentSubFolderPathFromSharePoint,
  convertUserLoginToSharepointUser,
  validatePhoneNumber,
  validateRequests,
};

export function isStringifiedJson(str: any): boolean {
  if (typeof str !== "string") return false;

  try {
    const parsed = JSON.parse(str);

    // JSON.stringify chỉ tạo ra object, array, number, string, boolean, null
    const type = typeof parsed;

    return parsed === null || type === "object" || type === "number" || type === "boolean" || type === "string";
  } catch (e) {
    return false;
  }
}

export function parseStringifiedJson(str: any): any {
  if (!isStringifiedJson(str)) return str;

  const result = JSON.parse(str);

  const keys = Object.keys(result);

  return keys.reduce((curr, key) => {
    return {
      ...curr,
      [key]: parseStringifiedJson(result[key]),
    };
  }, {});
}
